module.exports = __webpack_public_path__ + "static/media/kruger-policy.0542b9cf.png";